










































import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Place from '../models/place.model';
import SearchTermChangeEvent from '@/models/search-term-change-event.model';
import SearchInputLayout from './SearchInputLayout.vue';
import State from '@/classes/state';

export default {
    name: 'SearchInput',
    components: {
        VueGoogleAutocomplete,
        SearchInputLayout,
    },
    props: {
        initialSearchTerm: {
            type: String,
            required: false,
        },
        valid: {
            type: Boolean,
            required: true,
        },
        errorMessage: {
            type: String,
            required: false
        },
        size: {
            type: String,
            required: false
        },
        locationButtonLoading: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        const state: State = this.$store.state;

        return {
            config: state.config,
            translations: state.translations,
            searchTerm: this.initialSearchTerm,
        };
    },
    computed: {
        inputSizeModifier(): string | null {
            if (this.size) {
                return `frm-text--${this.size}`;
            }

            return null;
        },
    },
    watch: {
        initialSearchTerm() {
            this.setSearchTerm();
        },
    },
    methods: {
        /**
         * Sets the initial search term
         */
        setSearchTerm() {
            this.$refs.googleAutocomplete.update(this.initialSearchTerm);
        },
        /**
         * Executed when the input changes
         */
        handleInputChange(e: SearchTermChangeEvent): void {
            this.searchTerm = e.newVal;
            this.$emit("inputChange", e);
        },
        /**
         * Executed when the user clicks
         * the location button
         */
        handleLocationButtonClick(e: Event): void {
            this.$emit("locationButtonClick", e);
        },
        /**
         * Executed when user selects a place
         */
        handlePlaceChange(e: any): void {
            // normalize provider specific event to place object
            const place: Place = {
                lng: e.longitude,
                lat: e.latitude,
            };

            this.$emit("placeChange", place);
        },
    },
    mounted() {
        this.setSearchTerm();
    },
};
